export default __webpack_public_path__ + "static/centre-banner-2a302ef4a67b1510f6380065d329efcf.svg";